import { useState, type ReactNode } from "react";
import { StatusBanner } from "./StatusBanner";
import { Sidebar, Topbar } from "./Sidebar";
import { titleForPath } from "../config/navigation";

export function AppShell({
  pathname,
  onNavigate,
  children,
  onLogout,
  sessionEmail,
}: {
  pathname: string;
  onNavigate: (path: string) => void;
  children: ReactNode;
  onLogout?: () => void;
  sessionEmail?: string;
}) {
  const [open, setOpen] = useState(false);
  const meta = titleForPath(pathname);
  const bare = pathname === "/login" || pathname === "/status" || pathname === "/setup";

  if (bare) {
    return (
      <div className="app-root">
        <StatusBanner />
        {children}
      </div>
    );
  }

  return (
    <div className="app-root">
      <StatusBanner />
      <div className="app-body">
        <div
          className={`sidebar-backdrop${open ? " visible" : ""}`}
          onClick={() => setOpen(false)}
          aria-hidden={!open}
        />
        <Sidebar
          pathname={pathname}
          open={open}
          onNavigate={(path) => {
            setOpen(false);
            onNavigate(path);
          }}
          onLogout={onLogout}
          sessionEmail={sessionEmail}
        />
        <div className="main-column">
          <Topbar title={meta.title} subtitle={meta.subtitle} onMenu={() => setOpen(true)} />
          <main className="page">{children}</main>
        </div>
      </div>
    </div>
  );
}
